export default __webpack_public_path__ + "static/media/Netflix_logo.5787551b.svg";